// extracted by mini-css-extract-plugin
module.exports = {"image":"_2JDz9EPBST6XHxug06joO6"};